// centered icon + message block used for error / empty / not-found states
export default function StateMessage({ icon: Icon, title, message }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-20 gap-y-3">
      {Icon ? <Icon className="text-5xl text-brand" /> : null}
      <h3 className="text-xl font-semibold text-ink">{title}</h3>
      {message ? <p className="text-muted max-w-md">{message}</p> : null}
    </div>
  );
}
